import * as React from 'react';
import * as DateFns from 'date-fns';
import { Dialog, Button, Input } from 'arbina-ui';
import { Item, PurchaseWallpaperItem, PurchaseWallpaperPack } from 'types';
import { Items } from './components/Items';
import * as style from './style.sass';

interface Properties {
  pack: PurchaseWallpaperPack;
  onClose: () => any;
  onSubmit: (pack: PurchaseWallpaperPack) => Promise<any>;
}

interface State {
  pack: PurchaseWallpaperPack;
  submitting: boolean;
}

export class EditDialog extends React.Component<Properties> {
  state: State = {
    pack: { ...this.props.pack },
    submitting: false,
  };

  onItemsChanged = (items: PurchaseWallpaperItem[]) => {
    this.setState({
      pack: {
        ...this.state.pack,
        items,
      },
    });
  }

  onSubmit = async () => {
    const { pack } = this.state;

    try {
      this.setState({ submitting: true });

      await this.props.onSubmit(pack);
    } finally {
      this.setState({ submitting: false });
    }
  }

  render() {
    const { onClose } = this.props;
    const { pack, submitting } = this.state;

    return (<Dialog
      title={`${pack.id ? 'Edit' : 'Add new'} purchase wallpapers pack`}
      onClose={onClose}
    >
      <div className={style.items}>
        <Items
          items={pack.items}
          onItemsChanged={this.onItemsChanged}
        />
      </div>
      <Button
        primary
        disabled={!pack.items.length || submitting}
        text="Save"
        onClick={this.onSubmit}
      />
    </Dialog>);
  }
}
